import {useCallback, useEffect, useRef} from 'react';

import {defaultColumnAdapter} from 'src/components/edit-columns/column-adapter';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';

import {useGateValue} from '@pb/kit-lib-statsig';

import {platformColumnAdapter} from './platform-columns';

import type {ColumnAdapter} from 'src/components/edit-columns/column-adapter';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';
import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

export const usePlatformColumn = () => {
    const enabled = useGateValue(STATSIG_GATES.ACCOUNT_PROVISIONING_HISTORY);
    const columnAdapter = enabled ? platformColumnAdapter : defaultColumnAdapter;
    const currentAdapter = useRef(columnAdapter);
    currentAdapter.current = columnAdapter;
    const getCurrentSorting = useCallback<ColumnAdapter['getSorting']>((column, direction) =>
        currentAdapter.current.getSorting(column, direction), []);
    return {enabled, columnAdapter, getCurrentSorting};
};

export const usePlatformSorting = (
    template: UserSearchTemplate,
    applySort: (column: string, direction: SortDirection) => void,
) => {
    const {enabled, columnAdapter} = usePlatformColumn();
    const previousGate = useRef(enabled);
    useEffect(() => {
        if (template.templateId === -1) {
            return;
        }
        if (previousGate.current !== enabled) {
            const {column, direction} = columnAdapter.getSorting(template.defaultSortColumn,
                template.defaultSortDirection);
            applySort(column, direction);
        }
        previousGate.current = enabled;
    }, [enabled, columnAdapter, template, applySort]);
};
